import { ApiService } from "./ApiService";
import { IContactsApiService } from "./IContactsApiService";
import { ContactModel } from "../models/ContactModel";
import { PagedModel } from "../models/PagedModel";

export class ContactsApiService extends ApiService implements IContactsApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    getContacts(
        page?: number,
        perPage?: number,
        sortField?: "name" | "email",
        sortDirection?: "ascending" | "descending",
        searchString?: string,
        onBehalfOf?: string
    ): Promise<PagedModel<ContactModel>> {
        return this.get<PagedModel<ContactModel>>("contacts", {
            page,
            perPage,
            sortField,
            sortDirection,
            searchString,
            onBehalfOf,
        });
    }
}
